export class DisplayGroup {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly order: number,
    public readonly categoryPaths: string[] = [],
  ) {}
}
